module.exports = __webpack_public_path__ + "static/media/galleryBackground.8e705771.png";